module.exports = __webpack_public_path__ + "static/media/logo-marido.ed8bf57a.png";